import { useSnackbar } from "notistack";
import { useState, useEffect } from "react";

import { Event } from "../../../dtos/event";
import { LogFilterRequest } from "../../../rest/requestObjects/eventLogRequest";
import { AjaxResult } from "../../../enums/ajaxResult";
import { useApi } from "../../useApi";

export function useEvents(
    dealerId: number | undefined,
    orgId: number | undefined,
    siteId: number | undefined,
    request: LogFilterRequest,
): {
    numberOfPages: number;
    isLoading: boolean;
    events: Event[];
} {
    const { enqueueSnackbar } = useSnackbar();
    const { eventApi } = useApi();
    const [numberOfPages, setNumberOfPages] = useState(0);
    const [events, setEvents] = useState<Event[]>([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const abortController = new AbortController();
        let apiMethod = () => eventApi.getEvents(request, abortController);
        if (dealerId && !orgId && !siteId) {
            apiMethod = () =>
                eventApi.getEventsForDealer(dealerId, request, abortController);
        }
        if (orgId && !siteId) {
            apiMethod = () => eventApi.getEventsForOrg(orgId, request, abortController);
        }
        if (siteId && orgId) {
            apiMethod = () =>
                eventApi.getEventsForSite(orgId, siteId, request, abortController);
        }
        setIsLoading(true);
        apiMethod().then((r) => {
            if (r.result === AjaxResult.Success && r.data) {
                setEvents(r.data.events);
                setNumberOfPages(r.data.numberOfPages);
                setIsLoading(false);
            } else if (r.result !== AjaxResult.Cancelled) {
                enqueueSnackbar("Couldnt get events!");
                setIsLoading(false);
            }
        });
        return () => abortController.abort();
    }, [request, dealerId, orgId, siteId, eventApi, enqueueSnackbar]);

    return {
        numberOfPages,
        isLoading,
        events,
    };
};
